import React from 'react';
import { Box, TextField } from '@mui/material';

function SearchInput({ placeholder, value, onChange }) {
    return (
        <Box>
            <TextField
                placeholder={placeholder}
                type='text'
                variant="standard"
                InputProps={{
                    disableUnderline: true,
                }}
                // fullWidth
                value={value}
                sx={{
                    px: 1,
                    width: '100%'
                }}
                onChange={(e) => onChange(e.target.value)}
            />
        </Box>
    );
}


export default SearchInput;
